var React = require('react');

function Note (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","height":"24","width":"24","key":0}),React.createElement("path",{"fill":"currentColor","d":"M19,5v9l-5,0l0,5H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h10l6-6V5C21,3.9,20.1,3,19,3z M12,14H7v-2h5V14z M17,10H7V8h10V10z","key":1})]);
}

Note.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Note;

Note.default = Note;
